import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import { identity, pickBy } from 'lodash';
import useDebounce from 'hooks/useDebounce';
import { useQuery } from 'hooks/useQuery';

interface IProps {
  onSearch(value: string): void;
}

const Search = ({ onSearch }: IProps) => {
  const history = useHistory();
  const params = useQuery();

  const articleId = params.get('articleId');
  const section = params.get('section');
  const search = params.get('search');

  const isFirstRender = useRef(true);
  const [query, setQuery] = useState(search || '');
  const debouncedValue = useDebounce<string>(query, 1000);

  const handleSearchMenu = useCallback((value: string) => {
    setQuery(value);
  }, []);

  // поиск могли сбросить снаружи (например переходом по хлебным крошкам) — очищаем поле
  useEffect(() => {
    setQuery(search || '');
  }, [search]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (debouncedValue === (search || '')) return;

    history.push({ search: qs.stringify(pickBy({ section, articleId, search: debouncedValue }, identity)) });
    onSearch(debouncedValue);
  }, [debouncedValue]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TextField
      value={query}
      type="search"
      label="Поиск"
      variant="filled"
      size="small"
      onChange={(event) => handleSearchMenu(event.target.value)}
    />
  );
};

export default Search;
